import React from "react";
import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";

const FACEBOOK_URL = "https://www.facebook.com/share/19fbeYRHU5/?mibextid=wwXIfr";

export default function Footer({ business, contact, logoUrl }) {
    const year = new Date().getFullYear();
    return (
        <footer className="relative bg-black border-t border-zinc-900">
            {/* Massive ribbon */}
            <div className="overflow-hidden border-b border-zinc-900">
                <div className="marquee flex whitespace-nowrap py-6 font-display text-6xl md:text-7xl text-yellow-400/90">
                    <span className="px-8">RUIZ CONCRET3</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">DRIVEWAYS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">STAMPED</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">PATIOS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">SIDEWALKS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">COLORADO SPRINGS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">RUIZ CONCRET3</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">DRIVEWAYS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">STAMPED</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">PATIOS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">SIDEWALKS</span>
                    <span className="px-8 text-yellow-400/40">///</span>
                    <span className="px-8">COLORADO SPRINGS</span>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
                <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-3">
                            <img
                                src={logoUrl}
                                alt="Ruiz Concrete"
                                className="h-16 w-16 object-cover"
                            />
                            <div>
                                <div className="font-display text-white text-3xl">
                                    {business?.name || "Ruiz Concret3 LLC"}
                                </div>
                                <div className="font-mono-accent text-[10px] text-yellow-400">
                                    {business?.tagline}
                                </div>
                            </div>
                        </div>
                        <p className="mt-6 max-w-md text-zinc-500 text-sm leading-relaxed">
                            Family-owned concrete contractor serving Colorado Springs & the Front
                            Range. Warranty & fully insured.
                        </p>
                        {/* Social */}
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href={FACEBOOK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Ruiz Concret3 on Facebook"
                                data-testid="footer-facebook"
                                className="w-11 h-11 border border-zinc-800 hover:border-yellow-400 hover:bg-yellow-400 hover:text-black text-zinc-300 flex items-center justify-center transition-colors group"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>
                            <span className="font-mono-accent text-[10px] text-zinc-600">
                                FOLLOW US
                            </span>
                        </div>
                    </div>

                    <div>
                        <div className="font-mono-accent text-[10px] text-zinc-500 mb-4">
                            CONTACT
                        </div>
                        <ul className="space-y-3 text-zinc-300 text-sm">
                            <li>
                                <a
                                    href={`tel:${contact?.phone?.replace(/[^\d+]/g, "")}`}
                                    className="hover:text-yellow-400 transition-colors"
                                >
                                    {contact?.phone}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${contact?.email}`}
                                    className="hover:text-yellow-400 transition-colors break-all"
                                >
                                    {contact?.email}
                                </a>
                            </li>
                            <li className="text-zinc-500">{contact?.hours}</li>
                        </ul>
                    </div>

                    <div>
                        <div className="font-mono-accent text-[10px] text-zinc-500 mb-4">
                            SERVICE AREAS
                        </div>
                        <ul className="space-y-2 text-zinc-300 text-sm">
                            {(contact?.service_area || "")
                                .split(/[·,]/)
                                .map((c) => c.trim())
                                .filter(Boolean)
                                .map((city) => (
                                    <li key={city} className="text-zinc-400">
                                        {city}
                                    </li>
                                ))}
                        </ul>
                    </div>

                    <div>
                        <div className="font-mono-accent text-[10px] text-zinc-500 mb-4">
                            EXPLORE
                        </div>
                        <ul className="space-y-3 text-zinc-300 text-sm">
                            <li>
                                <a href="#services" className="hover:text-yellow-400">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="#portfolio" className="hover:text-yellow-400">
                                    Portfolio
                                </a>
                            </li>
                            <li>
                                <a href="#reviews" className="hover:text-yellow-400">
                                    Reviews
                                </a>
                            </li>
                            <li>
                                <a href="#quote" className="hover:text-yellow-400">
                                    Free Quote
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/admin/login"
                                    data-testid="footer-admin-link"
                                    className="text-zinc-600 hover:text-yellow-400 font-mono-accent text-[10px]"
                                >
                                    [ ADMIN ]
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-zinc-900 flex flex-col md:flex-row items-center justify-between gap-4 text-zinc-600 font-mono-accent text-[10px]">
                    <div>© {year} RUIZ CONCRET3 LLC · ALL RIGHTS RESERVED</div>
                    <div>COLORADO SPRINGS, CO · MADE WITH CONCRETE + CODE</div>
                </div>
            </div>
        </footer>
    );
}
